module.exports = __webpack_public_path__ + "static/matthew-0dd37a332d5aee9952b75ae138399772.jpg";